module.exports = __webpack_public_path__ + "img/index-solution-04.f80869b1.jpg";